import React from 'react'
import { Alert, Button, Col, Row, Form } from 'react-bootstrap'
import { ModalContainer, ModalDialog } from 'react-modal-dialog';

const DeleteCareUnitDialog = (
    {deleteErrorMessage,
        onDeleteClicked,
        onCancelClicked,
        careUnitForm: {
            emailUsername,
            emailUsernameRepetition,
            organizationId,
            name,
            streetAddress,
            zipCode,
            city,
            contactName,
            contactPhoneNumber,
            clinicInfo
        },
    }) => {
    return (
    <div className="DeleteCareUnitDialog">
        <ModalContainer>
                <ModalDialog>
                    <div><h3>Ta bort vårdenhet</h3></div>

                    {deleteErrorMessage &&
                        <Alert bsStyle="danger">{deleteErrorMessage}</Alert>
                    }
                    <Form id="saveCareUnitForm" className="SaveCareUnitForm" style={{width: '360px'}}
                          onSubmit={(e)=>{
                              e.preventDefault();
                              e.stopPropagation();
                          }}>
                        <Row>
                            <Col sm={12}>
                                    <p>Är du säker på att du vill ta bort vårdenheten, {name}?</p>
                                    <Button onClick={onCancelClicked} style={{marginLeft: '5px'}}>
                                        Avbryt
                                    </Button>
                                    <Button bsStyle={'primary'}
                                            style={{marginLeft: '5px'}}
                                            onClick={() => {onDeleteClicked({organizationId})}}>Ta bort vårdenhet</Button>
                            </Col>
                        </Row>
                    </Form>
            </ModalDialog>
        </ModalContainer>
    </div>
    )}
export default DeleteCareUnitDialog;